import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useOrganiseBranches = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (ids: string[]) => {
      dispatch({
        type: 'ORGANISE_BRANCHES',
        payload: {
          ids,
        },
      });
    },
    [dispatch],
  );
};
